const BrandLogo = ({ compact = false, className = "" }) => (
  <div
    className={`inline-flex items-center ${className}`}
    aria-label="Rezzil"
    data-testid="rezzil-logo"
  >
    <img
      src={`${process.env.PUBLIC_URL}/assets/imgs/Rezzil-Logo-White-Powered-By-1.png`}
      alt="Rezzil"
      className={compact ? "h-[27px] w-auto" : "h-10 w-auto"}
      draggable="false"
    />
  </div>
);

export default BrandLogo;
